import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { setIsAuthorized } from '../setIsAuthorized'
import { resetProfileInfo } from '../../../Profile/actions'
import { resetState } from '../../../../ads/edit/actions'

export const logout = () => {
  return (dispatch) => {
    try {
      const cookie = new CookiesHelper()
      cookie.remove('token')
      cookie.remove('userId')
      cookie.remove('userName')
      cookie.remove('userLogin')
      dispatch(resetProfileInfo())
      dispatch(resetState())
      dispatch(setIsAuthorized(false))
    } catch (error) {
      dispatch(setIsAuthorized(false))
    }
  }
}
